<template>
    <aside class="top-creator">
        <div class="top-box">
            <div class="title">Top Performing Creators</div>
            <div class="type-box">
                <Button v-for="(v, k) in button_list" size="32" :color="'black-90'"
                            @click.native="type = v.index; fetchData();"
                            :style="`${v.index === type ? 'border-square' : 'no-border-square'}`">{{ v.name
                            }}</Button>
                
            </div>
            <Loading class="static" v-if="is_loading"  />
            <div v-else-if="!is_loading && (data.length !== 0 && (
                (type === 1 && sum_views !== 0) || 
                (type === 2 && sum_click !== 0) || 
                (type === 3 && sum_sales !== 0) || 
                (type === 4 && sum_sales_value !== 0) ||
                (type === 5 && sum_earnings !== 0)))">
                <div class="item" v-for="(item, index) in data" @click="open(item)" :class="{'hide' : 
                (type === 1 && item.views === 0) || 
                (type === 2 && item.click === 0) || 
                (type === 3 && item.sales === 0) || 
                (type === 4 && item.sales_value === 0) ||
                (type === 5 && item.earnings === 0)}">
                    <figure class="avatar">
                        <img v-if="item.userProfile" :src="item.userProfile.avatar_full_url" @error="imageError($event)" />
                    </figure>
                    <div class="info">
                        <div class="text">{{ item.first_name + ' ' + item.last_name }}</div>
                        <div v-if="item.motom_handle" class="sub">@{{ item.motom_handle }}</div>
                        <div v-else-if="item.tiktok_handle" class="sub">{{ item.tiktok_handle }}</div>
                        <div v-else-if="item.instagram_handle" class="sub">@{{ item.instagram_handle }}</div>
                    </div>
                    <div v-if="type === 1" class="value">{{ formatNumber(item.views) }}</div>
                    <div v-else-if="type === 2" class="value">{{ formatNumber(item.click) }}</div>
                    <div v-else-if="type === 3" class="value">{{ formatNumber(item.sales) }}</div>
                    <div v-else-if="type === 4" class="value">${{ formatMoney(item.sales_value) }}</div>
                    <div v-else-if="type === 5" class="value">${{ formatMoney(item.earnings) }}</div>
                </div>
            </div>
            <div v-else-if="!is_loading">
                <NoData :image="require('@/assets/images/cart.png')" text="" title="No data available"/>
            </div>
        </div>
    </aside>
</template>

<script>
import Loading from '@/components/ui/Loading.vue';
import formatMoney from '@/utils/formatMoney';
import moment from 'moment';
import NoData from '@/components/creator/NoData.vue';
import Button from '@/components/ui/Button.vue';

export default {
    name: 'TopCreator',

    components: {
        Loading,
        NoData,
        Button,
    },

    data() {
        return {
            is_loading: true,
            type: 1,
            sum_views: 0,
            sum_click: 0,
            sum_sales: 0,
            sum_sales_value: 0,
            // (type === 1 && item.views === 0) || 
            //     (type === 2 && item.click === 0) || 
            //     (type === 3 && item.sales === 0) || 
            //     (type === 4 && item.sales_value === 0)}">
            data: [],
            button_list:[
                {name:'Views' ,index:1},
                {name:'Clicks' ,index:2},
                {name:'Sales' ,index:3},
                {name:'Sales Value' ,index:4},
                // {name:'Earnings' ,index:5},
            ],
            sortlink_data:0
        }
    },

    props: {
        start_date: {
            type: [Date,String],
            default: null,
        },

        end_date: {
            type: [Date,String],
            default: null,
        },
        
        selected_creator_tags: {
            type: Array,
            default: () => []
        },
        creator_tag_operation_type: {
            type: String,
            default: 'or'
        }

    },

    computed:{
        permission_creator(){
            return this.$store.state.user_data?.permission_list?.creatorManagement;
        }
    },

    methods: {
        formatNumber(num) {
            return num ? num.toLocaleString('en-US') : '--';
        },

        formatMoney: formatMoney,

        fetchData() {
            if(this.$store.state.user_data.merchant_account_id){
                this.is_loading = true;
                let s = moment(this.start_date).format('YYYY-MM-DD');
                let e = moment(this.end_date).format('YYYY-MM-DD');
                let sort_key = '';
                switch (this.type) {
                    case 1:
                        sort_key = 'views';
                        break;
                    
                    case 2:
                        sort_key = 'click';
                        break;

                    case 3:
                        sort_key = 'sales';
                        break;

                    case 4:
                        sort_key = 'sales_value';
                        break;

                    case 5:
                        sort_key = 'earnings';
                        break;
                
                    default:
                        break;
                }

                let api = `/analytics/top-performing-creators?start_date=${s}&end_date=${e}&sort_key=${sort_key}&is_include_shortlink_data=${this.sortlink_data}`;

                // Add creator tag filters
                if (this.selected_creator_tags && this.selected_creator_tags.length > 0) {
                    this.selected_creator_tags.forEach(tag => {
                        api += `&creator_tag_ids[]=${tag.id}`;
                    });
                    api += `&operation_type=${this.creator_tag_operation_type}`;
                }

                this.$ajax(api, {
                    method: 'get',
                    withCredentials: true,
                }).then(res => {
                    res.data.forEach(item => {
                        this.sum_views =  (this.sum_views + item.views);
                        this.sum_click =  (this.sum_click + item.click);
                        this.sum_sales =  (this.sum_sales + item.sales);
                        this.sum_sales_value =  (this.sum_sales_value + item.sales_value);
                    });

                    this.data = res.data;
                    this.is_loading = false;
                    this.$emit('top_data', {type:'top-creator', data: true});
                });
            }
        },

        open(data) {
            let d = {
                "user_id": data.id,
                "start_date": this.start_date,
                "end_date": this.end_date
            };
            this.EventBus.emit('open-creator-modal', d);
        },

        imageError(event) {
            event.target.src = require('@/assets/images/user.png');
        },

    },

    mounted() {
        this.button_list.push({name:'Earnings' ,index:5});
        this.sortlink_data= this.$store.state.save_sortlink_data;
        this.fetchData();
    },
}
</script>
<style lang="scss">
    .top-creator {

        .top-box {
            padding: 12px;
            border: 1px solid var(--black-20);
            border-radius: 10px;
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);

            .creator-no-data img {
                width: 120px;
            }

            .title {
                font: var(--font-demi-20);
                color: var(--text-primary);
                display: flex;
                align-items: center;
                
                svg {
                    width: 16px;
                    height: 16px;
                    margin-right: 6px;
                }
            }

            .type-box {
                margin-top: 8px;
                display: flex;

                .ui-button{
                    font: var(--font-fg-14);
                    margin-right: 4px;
                    padding:  0 12px;
                }

                .type {
                    padding: 8px 12px;
                    font: var(--font-fg-14);
                    color: var(--black-60);
                    border-radius: 100px;
                    cursor: pointer;

                    &.selected {
                        color: var(--dark-blue);
                        background: #FAFAFA;
                    }
                }
            }

            hr {
                border-top: 1px solid var(--black-20);
                overflow: hidden;
                height: 0px;
                border-bottom: 0;
            }

            .item {
                margin-top: 8px;
                padding: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                &.hide {
                    display: none;
                }

                &:hover {
                    background: var(--bg-08);
                }

                .avatar {
                    margin-right: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        width: 32px;
                        height: 32px;
                        border-radius: 50%;
                        border: 1px solid var(--black-40);
                    }
                }

                .info {
                    flex: 1;

                    .text {
                        font: var(--font-fg-12);
                        color: var(--black-90);
                    }

                    .sub {
                        font-weight: 500;
                        font-size: 12px;
                        line-height: 14px;
                        color: var(--black-50);
                    }
                }
            }
        }
    }
</style>